module.exports = __webpack_public_path__ + "img/battery_3purple.16b66732.png";